var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarLine16(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 0.671875V2.00521H10.0007V0.671875H11.334V2.00521H14.0007C14.3689 2.00521 14.6673 2.30369 14.6673 2.67187V13.3385C14.6673 13.7067 14.3689 14.0052 14.0007 14.0052H2.00065C1.63246 14.0052 1.33398 13.7067 1.33398 13.3385V2.67187C1.33398 2.30369 1.63246 2.00521 2.00065 2.00521H4.66732V0.671875H6.00065ZM13.334 7.33854H2.66732V12.6719H13.334V7.33854ZM4.66732 3.33854H2.66732V6.00521H13.334V3.33854H11.334V4.67187H10.0007V3.33854H6.00065V4.67187H4.66732V3.33854Z",
    fill: "#627078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine16);
export default __webpack_public_path__ + "static/media/calendar-line-16.6ec9bf491f5b2c3ef48a3c7e5276bab2.svg";
export { ForwardRef as ReactComponent };